/**
 * 検証結果。エラーは公開を止め、警告は表示だけして公開できる(docs/20 §4)。
 */
export interface ValidationResult {
  readonly errors: readonly string[];
  readonly warnings: readonly string[];
}

export function createIssues(): {
  readonly errors: string[];
  readonly warnings: string[];
  readonly result: () => ValidationResult;
} {
  const errors: string[] = [];
  const warnings: string[] = [];
  return { errors, warnings, result: () => ({ errors: [...errors], warnings: [...warnings] }) };
}

export function mergeResults(...results: readonly ValidationResult[]): ValidationResult {
  return {
    errors: results.flatMap((result) => result.errors),
    warnings: results.flatMap((result) => result.warnings),
  };
}

/** `map` の `key` の配列へ `value` を足す(無ければ作る)。配列を作り直さない。 */
export function appendTo<K, V>(map: Map<K, V[]>, key: K, value: V): void {
  const list = map.get(key);
  if (list === undefined) map.set(key, [value]);
  else list.push(value);
}
